import { Component, Inject, OnInit, ViewChild} from '@angular/core';
import { NivelacionesService} from '../_services/nivelaciones.service';
import { Observable} from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CustomAlertService} from "../../../_components/custom-alert/custom-alert.service";

@Component({
  selector: 'nivelaciones-especiales-alumnos',
  standalone: false,
  templateUrl: 'nivelaciones-especiales-alumnos.component.html'
})

export class NivelacionesEspecialesAlumnosComponent implements OnInit {

  materias$: Observable<any>;

  loading = false;
  displayedColumns = ['Alumnos'];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  materiaID;

  franjasPost: any[] = [];

  constructor(public nivelacionesService: NivelacionesService,
              public dialogRef: MatDialogRef<NivelacionesEspecialesAlumnosComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private customAlertService: CustomAlertService) {
  }

  ngOnInit() {
    this.materias$ = this.nivelacionesService.getMateriasEspeciales();
  }

  getAlumnos(evt) {
    const materiaID = evt.value,
      that = this;

    this.materiaID = materiaID;
    this.loading = true;
    this.nivelacionesService.getAlumnosMateriaEspecial(materiaID, this.data.fecha).subscribe(res => {
      const data = this.nivelacionesService.extractData(res);
      this.dataSource = new MatTableDataSource<any>(data);
      this.loading = false;
      if (data.length > 0) {
        data[0].franjas.map(franja => {
          this.displayedColumns.push(`${franja.horaCita}`);
        });
      }
      setTimeout(() => {
        that.dataSource.paginator = that.paginator;
      }, 750);
    }, err => {

    });
  }

  getFranja(alumno, franjaHora) {
    return alumno.franjas.find(cFranja => cFranja.horaCita === franjaHora);
  }

  franjaChange(evt) {
    if (evt.checked) {
      this.franjasPost.push(Object.assign({}, evt.source.value));
    } else {
      const index = this.franjasPost.findIndex(cFranja => +cFranja.alumnoID === +evt.source.value.alumnoID
        && cFranja.hora === evt.source.value.hora);
      if (index > -1) {
        this.franjasPost.splice(index, 1);
      }
    }
    evt.source.value.citado = evt.checked;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }

  guardar() {
    const model = {
      fecha: this.data.fecha,
      materiaId: this.materiaID,
      franjas: this.franjasPost
    };

    this.nivelacionesService.setNivelacionesEspeciales(model).subscribe(res => {
      this.dialogRef.close(res);
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible guardar. <br> Código de error: ${err.statusText}`
      });
    });
  }

  close() {
    this.dialogRef.close();
  }
}
